import axios from 'axios';

/**
 * Get JWT token from WordPress localized data
 */
const getJwtToken = () => {
    if (typeof window !== 'undefined' && typeof window.octopusReactData !== 'undefined') {
        return window.octopusReactData.jwtToken;
    }
    return null;
};

/**
 * Get API URL from WordPress localized data
 */
const getApiUrl = () => {
    if (typeof window !== 'undefined' && typeof window.octopusReactData !== 'undefined') {
        return window.octopusReactData.apiUrl;
    }
    return '';
};

/**
 * Create Axios instance with default configuration
 */
const axiosInstance = axios.create({
    timeout: 30000, // 30 seconds timeout
    headers: {
        'Content-Type': 'application/json',
    },
});

/**
 * Request interceptor - Add JWT token to all requests
 */
axiosInstance.interceptors.request.use(
    (config) => {
        // Get base URL dynamically
        if (!config.baseURL && !config.url?.startsWith('http')) {
            config.baseURL = getApiUrl();
        }
        
        // Add JWT token
        const token = getJwtToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

/**
 * Response interceptor - Handle errors globally
 */
axiosInstance.interceptors.response.use(
    (response) => {
        // Return response data directly
        return response.data;
    },
    (error) => {
        // Handle different error types
        if (error.response) {
            // Server responded with error status
            const { status, data } = error.response;
            
            switch (status) {
                case 401:
                    console.error('Unauthorized: Invalid or expired token');
                    // You can dispatch a logout action here if needed
                    break;
                case 403:
                    console.error('Forbidden: Insufficient permissions');
                    break;
                case 404:
                    console.error('Not Found:', data.message || 'Resource not found');
                    break;
                case 500:
                    console.error('Server Error:', data.message || 'Internal server error');
                    break;
                default:
                    console.error(`Error ${status}:`, data.message || 'Request failed');
            }
            
            return Promise.reject({
                status,
                message: data.message || 'Request failed',
                data
            });
        } else if (error.request) {
            // Request was made but no response received
            console.error('Network Error: No response received');
            return Promise.reject({
                status: 0,
                message: 'Network error. Please check your connection.',
                error
            });
        } else {
            // Something else happened
            console.error('Request Error:', error.message);
            return Promise.reject({
                status: 0,
                message: error.message || 'Request failed',
                error
            });
        }
    }
);

export default axiosInstance;

